// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__eAYi-"};